import { KeyValue } from '@/main/models/common';

export enum QuoteImportStatusTypes {
  GET_QUOTE_IMPORT_STATUS = '@quoteImportStatus/GET_QUOTE_IMPORT_STATUS',
  SAVE_QUOTE_IMPORT_STATUS = '@quoteImportStatus/SAVE_QUOTE_IMPORT_STATUS',
  RESET_REDUCER_QUOTE_IMPORT_STATUS = '@quoteImportStatus/RESET_REDUCER_QUOTE_IMPORT_STATUS'
}

export interface QuoteImportStatusState {
  readonly quoteImportStatus: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetQuoteImportStatus {
  type: typeof QuoteImportStatusTypes.GET_QUOTE_IMPORT_STATUS;
}

export interface SaveQuoteImportStatus {
  type: typeof QuoteImportStatusTypes.SAVE_QUOTE_IMPORT_STATUS;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerQuoteImportStatus {
  type: typeof QuoteImportStatusTypes.RESET_REDUCER_QUOTE_IMPORT_STATUS;
}

export type QuoteImportStatusActionTypes =
  | GetQuoteImportStatus
  | SaveQuoteImportStatus
  | ResetReducerQuoteImportStatus;

